import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarouselTemplate from '@segment/templates/LogoCarousel'

import { carouselLogos } from '@segment/templates/LogoCarousel/data'

const logos = [
  carouselLogos.ROKFIN,
  carouselLogos.TOGGLE,
  carouselLogos.GOOD_EGGS,
  carouselLogos.ALLERGAN,
  carouselLogos.DOMINOS,
  carouselLogos.SANOFI,
  carouselLogos.BOX,
  carouselLogos.CRAFTJACK,
  carouselLogos.VACASA,
]

const LogoCarousel = () => (
  <StyledSection variant="noCopy">
    <Section.Contents>
      <LogoCarouselTemplate logos={logos} />
    </Section.Contents>
  </StyledSection>
)

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 4px;
    padding-bottom: 4px;

    ${({ theme }) => theme.breakpoints.up(`sm`)} {
      padding-top: 44px;
      padding-bottom: 20px;
    }
  }
`

export default LogoCarousel
